import { render, staticRenderFns } from "./FriendGroupManager.vue?vue&type=template&id=c930a5b4&scoped=true"
import script from "./FriendGroupManager.vue?vue&type=script&lang=js"
export * from "./FriendGroupManager.vue?vue&type=script&lang=js"
import style0 from "./FriendGroupManager.vue?vue&type=style&index=0&id=c930a5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c930a5b4",
  null
  
)

export default component.exports